import i18n from '@/plugins/i18n';
import CreditOffered from '@/api/resources/creditOffered';
import Reoffers from '@/api/resources/reoffers';

const state = {
  creditOffereds: [],
  creditOffered: {},
  reoffers: [],
  filterByNfeYears: [],
  created: false,
  filterByState: '',
  nfesToReoffer: {},
  reofferdWithSuccess: false,
  filterLogisticOperator: [
    {
      name: 'Organização de Catadores',
      kind: 'cooperative_association',
      selected: false,
    },
    {
      name: 'CAMR',
      kind: 'waste_merchant',
      selected: false,
    },
  ],
  filterMaterial: [
    {
      name: 'Papel',
      selected: false,
    },
    {
      name: 'Plástico',
      selected: false,
    },
    {
      name: 'Vidro',
      selected: false,
    },
    {
      name: 'Metal',
      selected: false,
    },
  ],
};

const getters = {
  getCreditOffereds: () => (state.creditOffereds),
  getCreditOffered: () => (state.creditOffered),
  getFilterLogisticOperator: () => (state.filterLogisticOperator),
  getFilterMaterial: () => (state.filterMaterial),
  getFilterByState: () => (state.filterByState),
  createdOffer: () => (state.created),
  getNfesToReoffer: () => (state.nfesToReoffer),
  getReofferWithSuccess: () => (state.reofferdWithSuccess),
  getReoffers: () => (state.reoffers),
  getFilterByNfeYears: () => (state.filterByNfeYears),
};

const actions = {
  fetchCreditOffereds({ commit, dispatch }, payload) {
    dispatch('initLoading');
    CreditOffered.index(payload).then((response) => {
      commit('setCreditOffereds', response);
      dispatch('removeLoading');
    });
  },

  fetchNfesToReoffer({ commit, dispatch }, payload) {
    dispatch('initLoading');
    CreditOffered.nfes(payload).then((response) => {
      commit('setNfesToReoffer', response);
      dispatch('removeLoading');
    });
  },
  fetchCreditOffered({ commit, dispatch }, payload) {
    dispatch('initLoading');
    CreditOffered.show(payload).then((response) => {
      commit('setCreditOffered', response);
      dispatch('removeLoading');
    });
  },

  fetchTargetedCreditOffered({ commit, dispatch }, payload) {
    CreditOffered.showTargetedCreditOffered(payload).then((response) => {
      commit('setCreditOffered', response);
      dispatch('removeLoading');
    });
  },

  createOffer({ dispatch, commit }, payload) {
    dispatch('initLoading');
    commit('setCreated', false);
    CreditOffered.create(payload).then(() => {
      dispatch('fetchMyCredits', { business_id: payload.business_id });
      dispatch('fetchMyOffereds', payload.business_id);
      dispatch('removeLoading');
      dispatch('addSuccessMessage', i18n.t('success.created_credit'));
      commit('setCreated', true);
    });
  },

  createTargettedOffer({ dispatch, commit }, payload) {
    dispatch('initLoading');
    commit('setCreated', false);
    CreditOffered.createCreditOfferedTargetted(payload).then(() => {
      dispatch('fetchMyCredits', { business_id: payload.business_id });
      dispatch('fetchMyOffereds', payload.business_id);
      dispatch('removeLoading');
      dispatch('addSuccessMessage', i18n.t('success.created_credit'));
      commit('setCreated', true);
    });
  },

  createReoffer({ dispatch, commit }, payload) {
    dispatch('initLoading');
    commit('setReofferWithSuccess', false);

    Reoffers.create(payload).then(() => {
      dispatch('removeLoading');
      dispatch('addSuccessMessage', i18n.t('success.created_credit'));
      commit('setCreated', true);
      commit('setReofferWithSuccess', true);
    });
  },

  fetchReoffers({ dispatch, commit }, payload) {
    dispatch('initLoading');

    Reoffers.index(payload).then((response) => {
      commit('setReoffers', response);
    }).finally(() => {
      dispatch('removeLoading');
    });
  },

  changeFilterMaterial({ commit, getters }, index) {
    const filterMaterials = [...getters.getFilterMaterial];
    filterMaterials[index].selected = !filterMaterials[index].selected;
    commit('setFilterMaterial', filterMaterials);
  },

  changeFilterLogisticOperator({ commit, getters }, index) {
    const filterLogisticOperator = [...getters.getFilterLogisticOperator];
    filterLogisticOperator[index].selected = !filterLogisticOperator[index].selected;
    commit('setFilterLogisticOperator', filterLogisticOperator);
  },

  changeFilterByNfeYears({ commit }, payload) {
    commit('setFilterByNfeYears', payload);
  },

  changeFilterByState({ commit }, payload) {
    commit('setFilterByState', payload);
  },
};

const mutations = {
  setReofferWithSuccess($state, payload) {
    const stateCopy = $state;
    stateCopy.reofferdWithSuccess = payload;
  },

  setCreditOffereds($state, payload) {
    const stateCopy = $state;
    stateCopy.creditOffereds = payload;
  },

  setCreditOffered($state, payload) {
    const stateCopy = $state;
    stateCopy.creditOffered = payload;
  },

  setCreated($state, payload) {
    const stateCopy = $state;
    stateCopy.created = payload;
  },

  setFilterMaterial($state, payload) {
    const stateCopy = $state;
    stateCopy.filterMaterial = payload;
  },

  setFilterLogisticOperator($state, payload) {
    const stateCopy = $state;
    stateCopy.filterLogisticOperator = payload;
  },

  setFilterByState($state, payload) {
    const stateCopy = $state;
    stateCopy.filterByState = payload;
  },

  setNfesToReoffer($state, payload) {
    const stateCopy = $state;
    stateCopy.nfesToReoffer = payload;
  },

  setReoffers($state, payload) {
    const stateCopy = $state;
    stateCopy.reoffers = payload;
  },

  setFilterByNfeYears($state, payload) {
    const stateCopy = $state;
    const index = stateCopy.filterByNfeYears.findIndex((item) => item === payload);

    if (index >= 0) {
      stateCopy.filterByNfeYears.splice(index, 1);
    } else {
      stateCopy.filterByNfeYears.push(payload);
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
